import { MapProvider } from 'devextreme/ui/map';
import { useEffect } from 'react';

const useStyleObserver = (container: ShadowRoot, provider: MapProvider) => {
	useEffect(() => {
		if (!container || provider !== 'bing') return;
		const observer = new MutationObserver(mutations => {
			cloneBingStyles(container, mutations);
		});

		observer.observe(document.head, { childList: true });

		return () => observer.disconnect();
	}, [provider]);
};

const cloneBingStyles = (container: ShadowRoot, mutations: MutationRecord[]) => {
	mutations.forEach(mutation => {
		mutation.addedNodes.forEach(node => {
			if (
				node instanceof HTMLLinkElement &&
				node.rel === 'stylesheet' &&
				node.href.startsWith('https://r.bing.com') &&
				container
			) {
				const existingLink = Array.from(container.querySelectorAll('link')).find(
					link => link.href === node.href
				);
				if (!existingLink) {
					const clonedLink = document.createElement('link');
					clonedLink.rel = 'stylesheet';
					clonedLink.href = node.href;
					clonedLink.type = node.type;
					clonedLink.crossOrigin = node.crossOrigin;
					clonedLink.referrerPolicy = node.referrerPolicy;
					container.appendChild(clonedLink);
				}
			}
		});
	});
};

export { useStyleObserver };
